var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { contentStyles } from './RichTextContent.css';
export const RichTextContent = React.forwardRef(function RichTextContent(_a, ref) {
    var { as, children, className } = _a, rest = __rest(_a, ["as", "children", "className"]);
    const Component = as || 'div';
    const dangerouslySetInnerHTML = typeof children === 'string' ? { __html: children } : undefined;
    return (_jsx(Component, Object.assign({ className: cx(contentStyles, className), dangerouslySetInnerHTML: dangerouslySetInnerHTML, ref: ref }, rest, { children: dangerouslySetInnerHTML ? null : children })));
});
